module.exports = __webpack_public_path__ + "img/tick-sent.c46e56fe.svg";